import React from 'react';
import { styled as styled2 } from '@compiled/react';
import EmptyState from '@atlaskit/empty-state';
import ErrorIllustration from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/error/components/error/index.tsx';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const GraphError = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const renderImage = () =>
		getAkEmptyStateRenderImageFn(ErrorIllustration)({
			imageWidth: 120,
			maxImageWidth: 120,
			maxImageHeight: 212,
		});

	return (
		<Wrapper>
			<EmptyState
				header={formatMessage(messages.errorTitle)}
				description={formatMessage(messages.errorDescription)}
				renderImage={renderImage}
			/>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled2.div({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> *': {
		/* This prevents the built in margin on the EmptyState component making it grow larger than its container */
		boxSizing: 'border-box',
	},
});
